<template>
  <dashboard-modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
          selectedUrl
            ? `/accreditationreview/accreditations/update_send/${inputs.id}`
            : `/accreditationreview/accreditations/`
        "
      >
        <h6>¿Está seguro de enviar la solicitud N° {{inputs.code}}?</h6>
      </form>
    </template>
  </dashboard-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  name: "ApplicacionAddModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
  },
  data() {
    return {
      preloader: false,
      inputs: {},
      modalId: "send-add-edit-modal",
      modalTitle: this.$t("add"),
    };
  },

  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("Confirmar");
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      var data = {};
      data["id"] = this.inputs.id;
      this.save(data);
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      this.preloader = false;
    },
  },
};
</script>